import script from "./Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Container.vue?vue&type=script&setup=true&lang=js"

import "./Container.vue?vue&type=style&index=0&id=5b715afd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b715afd"]])

export default __exports__